import { STATUS_FA, STATUS_CLS } from '../constants'

// ─── Shared UI ────────────────────────────────────────────────────────────────

export function StatusBadge({ status }) {
  return (
    <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_CLS[status]}`}>
      {STATUS_FA[status]}
    </span>
  )
}

export function FIELD({ value, onChange, ...rest }) {
  return (
    <input
      value={value}
      onChange={onChange}
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
      {...rest}
    />
  )
}
